
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"orderUp":"Nach oben","orderDown":"Nach unten"},"en":{"orderUp":"Move up","orderDown":"Move down"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();